// FIXME: We are not importing via `~utils` due to a circular dependency
import { translate } from "utils/string-table";

import { CancelReasonKey, CancelReasonKeyType } from "./constants";
import type { CancelReasonConfig } from "./types";

export const reasonConfigs: CancelReasonConfig[] = [
  {
    reasonKey: CancelReasonKey.SubmitError,
    reasonText: translate("CANCEL_REQ_REASON_SUBMIT_ERROR"),
  },
  {
    reasonKey: CancelReasonKey.FilledByAltSrc,
    reasonText: translate("CANCEL_REQ_REASON_FILLED_BY_ALT_SRC"),
  },
  {
    reasonKey: CancelReasonKey.SubNotNeeded,
    reasonText: translate("CANCEL_REQ_REASON_SUB_NOT_NEEDED"),
  },
  {
    reasonKey: CancelReasonKey.Dissatisfied,
    reasonText: translate("CANCEL_REQ_REASON_DISSATISFIED"),
  },
  {
    reasonKey: CancelReasonKey.Other,
    reasonText: translate("CANCEL_REQ_REASON_OTHER"),
  },
];

export function getReasonConfigByKey(
  reasonKey: CancelReasonKeyType | undefined,
  reasonConfigs: CancelReasonConfig[],
): CancelReasonConfig | undefined {
  return reasonConfigs.find((cfg) => cfg.reasonKey === reasonKey);
}
